// extracted by mini-css-extract-plugin
export default {"title_box":"JapaneseAppComponent_title_box__IypKf","img_box":"JapaneseAppComponent_img_box__dro-Z","line":"JapaneseAppComponent_line__rtJvG","app":"JapaneseAppComponent_app__BBimH"};